import { useSelector } from 'react-redux';
import { AttainmentBarUserGoal } from '../attainmentBars/AttainmentBarUserGoal';
import { AttainmentBarTeamGoal } from '../attainmentBars/AttainmentBarTeamGoal';
import { AttainmentBarUserRollupGoal } from '../attainmentBars/AttainmentBarUserRollupGoal';
import { AttainmentBarNoGoal } from '../attainmentBars/AttainmentBarNoGoal';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { getIsAggregatedGoalsDataFetching } from '../../selectors/overviewSelectors';
import { TEAM } from '../../constants/AssigneeTypes';
import { RightAlignedTD } from '../styled/RightAlignedTD';
import { jsx as _jsx } from "react/jsx-runtime";
export const AttainmentCell = ({
  isDetailPage,
  onClickAttainmentBar,
  rowData,
  subscreen
}) => {
  const isDealStageView = useSelector(getIsDealStageView);
  const isLoadingGoals = useSelector(getIsAggregatedGoalsDataFetching);
  const {
    id,
    isUser,
    goal,
    closed,
    assigneeType
  } = rowData;
  const isExplicitTeamGoal = assigneeType === TEAM;
  const teamId = !isUser ? id : null;
  // All rows have clickable attainment bar except the "All Teams" totals row
  const handleClickAttainmentBar = rowData.id ? onClickAttainmentBar : () => {};
  let attainmentBar;
  if (!teamId && goal.value && id) {
    // user goal
    attainmentBar = /*#__PURE__*/_jsx(AttainmentBarUserGoal, {
      goal: goal,
      onClickAttainmentBar: handleClickAttainmentBar,
      value: closed || {},
      isLoadingGoal: isLoadingGoals
    });
  } else if (isExplicitTeamGoal) {
    // explicit team goal
    attainmentBar = /*#__PURE__*/_jsx(AttainmentBarTeamGoal, {
      goal: goal,
      onClickAttainmentBar: handleClickAttainmentBar,
      value: closed || {},
      isLoadingGoal: isLoadingGoals
    });
  } else if (goal.value) {
    // user rollup team goal
    attainmentBar = /*#__PURE__*/_jsx(AttainmentBarUserRollupGoal, {
      goal: goal,
      isDealStageView: isDealStageView,
      isDetailPage: isDetailPage,
      onClickAttainmentBar: handleClickAttainmentBar,
      subscreen: subscreen,
      teamId: teamId,
      value: closed || {},
      isLoadingGoal: isLoadingGoals
    });
  } else {
    // no goal
    attainmentBar = /*#__PURE__*/_jsx(AttainmentBarNoGoal, {
      isDealStageView: isDealStageView,
      isDetailPage: isDetailPage,
      onClickAttainmentBar: handleClickAttainmentBar,
      subscreen: subscreen,
      teamId: teamId,
      value: closed || {},
      isLoadingGoal: isLoadingGoals
    });
  }
  return /*#__PURE__*/_jsx(RightAlignedTD, {
    "data-test-id": "cell-wrapper",
    children: attainmentBar
  });
};
export default AttainmentCell;